import axios from 'axios'
import * as querystring from 'querystring'

import config from '../config/urlConfig'
import formatAxiosError from '../util/formatAxiosError'
import axiosOptions from '../const/axios-options'

export default class {
  static getSetting(key) {
    let queryString = querystring.stringify({ key: key })
    return axios
      .get(`${config.app.api}/api/setting?${queryString}`, axiosOptions)
      .then(response => {
        return response.data.settingValue
      })
      .catch(error => {
        let formatedError = formatAxiosError(error)
        throw formatedError
      })
  }
}
